<script lang="ts">
// components/I18nT2.vue

import { h, defineComponent } from 'vue'

export const I18nT2 = defineComponent({
  name: 'I18nT',
  props: {
    keypath: {
      type: String,
      required: true,
    },
    tag: {
      type: String,
      required: false,
      default: 'span',
    },
  },
  setup(props, context) {
    const { slots, attrs } = context
    const { t } = useI18n()
    return () => {
      const keys = Object.keys(slots).filter((key) => key !== '_')
      const options = keys.reduce((acc, key) => {
        const slot = slots[key]
        if (slot) {
          acc[key] = slot()
        }
        return acc
      }, {})
      const children = t(props.keypath, options, { flat: false })
      const tag =
        typeof props.tag === 'string' || typeof props.tag === 'object'
          ? props.tag
          : 'span'
      return h(tag, attrs, children)
    }
  },
})

export default I18nT2
</script>
